import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges, Inject, PLATFORM_ID } from '@angular/core'
import { NGXLogger } from 'ngx-logger'
import {fromEvent } from 'rxjs'
import {OfferInfo} from '../../../../core/helpers/interfaces'
import { SharedDataService } from 'src/app/core/services/shared-data.service'
import { isPlatformBrowser } from '@angular/common'

@Component({
    selector: 'app-modal-options-carousel',
    templateUrl: './modal-options-carousel.component.html',
    styleUrls: ['./modal-options-carousel.component.scss'],
    standalone: false
})
export class ModalOptionsCarouselComponent implements OnInit {

  constructor(
    public logger: NGXLogger,
    public sharedDataService: SharedDataService,
     @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  @Output() offerInfo: EventEmitter<unknown> = new EventEmitter()
  @Output() offerAmount: EventEmitter<unknown> = new EventEmitter()
  @Input() elements: OfferInfo[] = []
  @Input() breakpoints: any = {}
  @Input() loanAmount: any

  isPopup = false
  selectedElement = 0
  touchStartX = 0
  touchEndX = 0
  isPopupMobile = false;
  payIn4Open = false
  payIn4Loan = 0
  typeNumber = 1;
  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    setTimeout(() => {
      this.carouselNavigate(0)
    }, 400)
    fromEvent(document.querySelector('#carousel'), 'touchstart').subscribe((e: any) => {
      const carouselWrapper = document.querySelector('#carousel_w') as HTMLElement
      const touchobj = e.changedTouches[0]
      this.touchStartX = touchobj.clientX
    }, (error: any) => {
      console.error(error)
    })
    fromEvent(document.querySelector('#carousel'), 'touchend').subscribe((e: any) => {
      const carouselWrapper = document.querySelector('#carousel_w') as HTMLElement
      const touchobj = e.changedTouches[0]
      this.touchEndX = touchobj.clientX
      if (this.touchStartX !== this.touchEndX && Math.abs(this.touchStartX - this.touchEndX) > 30){
        if (this.touchEndX < this.touchStartX && this.selectedElement + 1 <= this.elements.length - 1){
          this.carouselNavigate(this.selectedElement + 1)
        }
        else if (this.touchEndX > this.touchStartX && this.selectedElement - 1 >= 0){
          this.carouselNavigate(this.selectedElement - 1)
        }
      }
    }, (error: any) => {
      console.error(error)
    })
    // fromEvent(document.querySelector('#carousel'), 'touchmove').subscribe(e => {
    //   const carouselWrapper = document.querySelector('#carousel_w') as HTMLElement
    //   const touchobj = e['changedTouches'][0]
    //   this.logger.info(touchobj)
    //   let ml = -(this.touchStartX - touchobj['clientX'])
    //   carouselWrapper.style.marginLeft = ml + 'px'
    // }, (error: any) => {
    //   console.error(error)
    // })
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.elements){
      this.offerAmount.emit(this.elements[0])
      if(!changes.elements.firstChange) {
        this.cardSelect(0)
      }
    }
  }

  carouselNavigate(to: number){
        if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.selectedElement = -1
    const visibleArea =  document.querySelector('#carousel').parentElement.parentElement as HTMLElement
    const visibleAreaWidth = +getComputedStyle(visibleArea).width.replace('px', '')
    const carouselWrapper = document.querySelector('#carousel_w') as HTMLElement
    const card = document.querySelector('.card') as HTMLElement
    const carouselWidth = +getComputedStyle(carouselWrapper).width.replace('px', '')
    const cardWidth = +getComputedStyle(card).width.replace('px', '')
    const cardMarginRight = +getComputedStyle(card).marginRight.replace('px', '')
    const cardMarginLeft = +getComputedStyle(card).marginRight.replace('px', '')
    // if (this.elements.length < 3 && !this.breakpoints.extraSmall){
    //   this.selectedElement = to
    //   return
    // }
      let initialMargin = visibleAreaWidth/2 - (cardMarginLeft +  cardMarginRight + cardWidth)*(2 * to + 1)/2
      let initialPadding = visibleAreaWidth
        carouselWrapper.style.marginLeft = initialMargin + 'px'
        carouselWrapper.style.paddingRight = initialPadding + 'px'
      // else if (to === this.elements.length - 1){
      //   let initialMargin
      //   if (visibleAreaWidth > (cardWidth + cardMarginLeft + cardMarginRight) * 2) {
      //    initialMargin = (1.5 * carouselWidth - visibleAreaWidth - 1.5 * cardMarginLeft - 1.5 * cardMarginRight) - cardWidth / 2
      //    carouselWrapper.style.marginLeft = 0 + 'px'
      //    carouselWrapper.style.marginRight = initialMargin + 'px'
      //   } else {
      //     initialMargin = (carouselWidth - visibleAreaWidth - cardMarginLeft - cardMarginRight)
      //     carouselWrapper.style.marginLeft = -initialMargin + 'px'
      //     carouselWrapper.style.marginRight = 0 + 'px'
      //   }
      // }
      // else if ( to !== this.centralElement()){
      //   let coefficent = 1
      //   if (this.elements.length % 2 === 0){
      //     coefficent = 0.5
      //   }
      //   const coef = 2 * (this.centralElement() - to)
      //   const initialMargin =  coefficent * coef * (cardMarginLeft + cardMarginRight + cardWidth)
      //   carouselWrapper.style.marginLeft = initialMargin + 'px'
      //   carouselWrapper.style.marginRight = 0 + 'px'
      // }
      // else{
      //   const coefficent = 1
      //   if (this.elements.length % 2 === 0){
      //     const initialMargin =  coefficent * (cardMarginLeft + cardMarginRight + cardWidth) 
      //     carouselWrapper.style.marginLeft = initialMargin + 'px'
      //     carouselWrapper.style.marginRight = 0 + 'px'
      //   }
      //   else{
      //     carouselWrapper.style.marginLeft = 0 + 'px'
      //     carouselWrapper.style.marginRight = 0 + 'px'
      //   }


      // }

    this.selectedElement = to

  }
cardSelect(idx){
  this.offerAmount.emit(this.elements[idx])
  this.carouselNavigate(idx)
}
  

selectedLessAmount(card){
    if(this.loanAmount && this.elements.length > 1 && card.autoPay.approvedAmount < this.loanAmount){
      if(card.autoPay.productSubType === 'TRUE_ZERO'){
        this.showPopup(card, 3)
      }
      else if(card.autoPay.productSubType === 'PAYINX'){
        this.showPopup(card, 4)
      }
    } else {
      this.onOfferSelect(card)
    }
  }

  onOfferSelect(e){
    this.offerInfo.emit(e)
  }

  flip(card) {
    this.logger.info('flip!')
    if (card.noAutoPay) {
      card.noAutoPayState = !card.noAutoPayState
    }
    // card.noAutoPay ?  : null
  }

  showPopup(card?: any, type?: number) {
    if (card) {
      card.isPopup = true
    }
    this.typeNumber = type
    // this.isPopupMobile = true
  }

  onPopupClosed(card?: any) {
    if (card) {
      card.isPopup = false
    }
    // this.isPopupMobile = false
  }


}
